/* eslint-disable react-hooks/rules-of-hooks */
import {useEffect} from 'react';

import localStorageClient from '../../../services/storage/localStorageClient';
import urlUtils from '../../../utils/urlUtils';

export const OFFLINE_DETECTOR_DISABLED_KEY = 'offlineDetectorDisabled';

const useDisableOfflineDetector = () => {
    if (process.env.REACT_APP_ENV === 'prod') return;

    const [isDisabled] = urlUtils.getDataFromUrl(OFFLINE_DETECTOR_DISABLED_KEY);

    useEffect(() => {
        if (isDisabled === 'true') {
            localStorageClient.setItem(OFFLINE_DETECTOR_DISABLED_KEY, true);
        } else if (isDisabled === 'false') {
            localStorageClient.removeItem(OFFLINE_DETECTOR_DISABLED_KEY);
        }
    }, [isDisabled]);
};

export default useDisableOfflineDetector;
